import { useScreenInfo } from 'hooks';
import { ConsignmentDetails } from 'types';
import { Accordion, Text } from 'components';
import { FontSize } from 'commons';
import * as S from './styles';
import { PrintLabel } from '../../../components';

interface Props {
  consignment: ConsignmentDetails;
  isPickupInStore: boolean;
}

export function WaitingInvoice({ consignment, isPickupInStore }: Props) {
  const { isMobile } = useScreenInfo();
  const { pointOfSale } = consignment;
  const isInvoice = pointOfSale.isInvoiceGenerator;

  return (
    <Accordion
      title={`Emissão ${isInvoice ? 'da nota' : 'do cupom'} fiscal`}
      defaultOpen={true}
    >
      <S.TextWrapper>
        <Text size={FontSize.font12} className="danger">
          <strong>Atenção!</strong> {isInvoice ? 'Sua Nota' : 'Seu Cupom'}{' '}
          fiscal está em emissão.{' '}
          {isPickupInStore
            ? 'Após a emissão o cliente será comunicado que poderá retirar o produto em sua loja.'
            : 'Uma transportadora será acionada para envio do pedido automaticamente após a emissão. Avisaremos quando estiver pronta.'}
        </Text>
      </S.TextWrapper>

      {!isMobile && <PrintLabel consignment={consignment} />}
    </Accordion>
  );
}
